import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-251a274f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "frame" }
const _hoisted_2 = { class: "controller" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["selected", "value"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["selected", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonIcon = _resolveComponent("ButtonIcon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "control-button",
          disabled: !_ctx.operational,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goBegin()))
        }, [
          _createVNode(_component_ButtonIcon, {
            class: "icon",
            icon: "first"
          })
        ], 8, _hoisted_3),
        _createElementVNode("button", {
          class: "control-button",
          disabled: !_ctx.operational,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goBack()))
        }, [
          _createVNode(_component_ButtonIcon, {
            class: "icon",
            icon: "back"
          })
        ], 8, _hoisted_4),
        _createElementVNode("button", {
          class: "control-button",
          disabled: !_ctx.operational,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goForward()))
        }, [
          _createVNode(_component_ButtonIcon, {
            class: "icon",
            icon: "next"
          })
        ], 8, _hoisted_5),
        _createElementVNode("button", {
          class: "control-button",
          disabled: !_ctx.operational,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goEnd()))
        }, [
          _createVNode(_component_ButtonIcon, {
            class: "icon",
            icon: "last"
          })
        ], 8, _hoisted_6)
      ]),
      _createElementVNode("select", {
        ref: "moveList",
        class: "move-list",
        size: "2",
        disabled: !_ctx.operational,
        onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeNumber()))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moves, (move) => {
          return (_openBlock(), _createElementBlock("option", {
            key: move.number,
            selected: move.selected,
            value: move.number
          }, _toDisplayString(move.number !== 0 ? move.number + " " : "") + " " + _toDisplayString(move.text) + " " + _toDisplayString(move.hasBranch ? " 分岐" : ""), 9, _hoisted_8))
        }), 128))
      ], 40, _hoisted_7),
      _createElementVNode("select", {
        ref: "branchList",
        class: "branch-list",
        size: "2",
        disabled: !_ctx.operational,
        onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeBranch()))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.branches, (branch) => {
          return (_openBlock(), _createElementBlock("option", {
            key: branch.index,
            selected: branch.selected,
            value: branch.index
          }, _toDisplayString(branch.text), 9, _hoisted_10))
        }), 128))
      ], 40, _hoisted_9)
    ])
  ]))
}